// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bbc_a"};